import React from 'react';
import PrivateComponent from '../../../providers/PrivateComponent/PrivateComponent';
import { PERMISSIONS } from '../../../utils/constants';
import { ProjectEditor } from '../../../components/projectEditor';
import { Button } from '@mui/material';

const ProjectPopup = ({ isOpen, onSave, onClose, onClick, sports, project }) => {
  return (
    <>
      {isOpen && <ProjectEditor
        onClose={onClose}
        onSave={onSave}
        isOpen={isOpen}
        sports={sports}
        initProject={project}
      />}
      <PrivateComponent permission={PERMISSIONS.ALLOW_WRITE_PROJECTS}>
        <Button
          variant="outlined"
          onClick={onClick}
          color="primary"
        >
          Create Project
        </Button>
      </PrivateComponent>
    </>
  );
}

export default ProjectPopup;
